import { useContext, useEffect, useState } from 'react';

import styles from './MobileQRComponent.module.css';

import { GlobalContext } from "../../../contexts/globalContext";
import { AddConferenceContext } from "../../../contexts/addConferenceContext";

import QRCode from "react-qr-code";
import { SignJWT } from 'jose';

const secretKey = new TextEncoder().encode("tekfinity-token");

const MobileQRComponent = ({ fromNote = false, top = 210, height = 370 }) => {
    const { currentConference, currentUser, currentParticipant } = useContext(GlobalContext);
    const { openFiles } = useContext(AddConferenceContext);

    const [qrCodeValue, setQrCodeValue] = useState('');

    useEffect(() => {
        if (!currentConference) return;

        const generateToken = async () => {
            const payload = {
                projectId: currentConference.project,
                conferenceId: currentConference._id,
                token: currentUser?.token || currentParticipant?.token,
                infoUser: currentParticipant?.email
            };

            if (fromNote) {
                payload.type = "notes";
            } else if (openFiles) {
                payload.topicId = openFiles._id;
                payload.type = openFiles.subtopics ? "topic" : openFiles.topicId || "file";
                payload.fileName = openFiles.name;
            }

            const jwt = await new SignJWT(payload)
                .setProtectedHeader({ alg: "HS256" })
                // .setExpirationTime("60s") 
                .sign(secretKey);

            const url = `https://conf.nextfusion.ro/mobile?token=${encodeURIComponent(jwt)}`;
            // const url = `http://localhost:3000/mobile?token=${encodeURIComponent(jwt)}`;
            console.log(url)
            setQrCodeValue(url);
        };

        generateToken();
    }, [currentConference, openFiles, currentUser, fromNote]);

    return (
        <>
            {fromNote ? 
                <div className={styles.componentNote}>
                    <QRCode
                        size={256}
                        className={styles.qrImage}
                        value={qrCodeValue}
                    />
                    <div className={styles.text}>
                        Scan to add notes.
                    </div>
                </div>
                : <div className={styles.componentTopics} style={{ top, height }}>
                    <div className={styles.whiteBorder}>
                        <QRCode
                            size={256}
                            className={styles.qrImage}
                            value={qrCodeValue}
                            style={{ width: "308px" }}
                        />
                    </div>
                </div>
            }
        </>

    );
};

export default MobileQRComponent;
